/**
 * Phase 21.0 — Beam Box capacity ladder.
 *
 * The Live Beam Box grid expands automatically as more speakers join:
 *   1–5  → 5 slots
 *   6–8  → 8 slots
 *   9–12 → 12 slots
 *  13–16 → 16 slots
 *  17–20 → 20 slots (current ceiling)
 *
 * Pure function — easy to unit-test.
 */
export const BEAM_LADDER = [5, 8, 12, 16, 20];
export const BEAM_MAX_CAPACITY = BEAM_LADDER[BEAM_LADDER.length - 1];

export function getBeamCapacity(speakerCount) {
  const n = Math.max(0, Number(speakerCount) || 0);
  for (const tier of BEAM_LADDER) {
    if (n <= tier) return tier;
  }
  return BEAM_MAX_CAPACITY;
}

/** Returns true when adding ONE more speaker would unlock the next tier. */
export function isExpansionThreshold(speakerCount) {
  const cur = getBeamCapacity(speakerCount);
  const next = getBeamCapacity(speakerCount + 1);
  return next > cur;
}

/** Map capacity → Tailwind grid class string for clean responsive layout. */
export function gridClassForCapacity(capacity) {
  if (capacity <= 5) return "grid-cols-2 sm:grid-cols-3";
  if (capacity === 8) return "grid-cols-2 sm:grid-cols-4";
  if (capacity === 12) return "grid-cols-3 sm:grid-cols-4";
  if (capacity === 16) return "grid-cols-3 sm:grid-cols-4 lg:grid-cols-4";
  return "grid-cols-3 sm:grid-cols-4 lg:grid-cols-5";
}
